import { storage } from "@/lib/storage";

export const SPACE_STATE_KEY = "opncue.space";

type SessionResetHandler = () => Promise<void> | void;

const sessionResetHandlers = new Set<SessionResetHandler>();

export function registerSessionReset(handler: SessionResetHandler) {
  sessionResetHandlers.add(handler);
  return () => sessionResetHandlers.delete(handler);
}

export async function resetRegisteredSessionState() {
  if (sessionResetHandlers.size) {
    await Promise.all([...sessionResetHandlers].map((handler) => handler()));
    return;
  }

  await storage.remove(SPACE_STATE_KEY);
}
